import {Component, inject, OnInit, OnDestroy, HostListener, effect, ErrorHandler} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import {Subject} from "rxjs";
import {PropertiesDialogDataSelect} from '@llm/service/utils_main_comp_variables.service';
import {llmStoreService} from '@llm/service/llm_store.service';
import {MicrophoneService} from '@serv/media_access/api_web_access_microphone.service';
import * as UtilityMediaAccess from '@serv/media_access/utility';
import { MarkdownModule } from 'ngx-markdown';
import {CustomErrorHandler} from "@llm/service/custom-error-handler";

/**
 * Componente de diálogo para selección de datos con reconocimiento de voz
 *
 * Este componente permite:
 * 1. Mostrar una lista de datos en formato de diálogo
 * 2. Seleccionar datos mediante comandos de voz
 * 3. Seleccionar datos mediante teclado numerico
 * 4. Interpretar números en diferentes formatos (verbal, ordinal, numérico)
 * 5. Manejar casos especiales como "último", "penúltimo"
 * 6. Proporcionar feedback visual del estado de reconocimiento
 *
 * @selector 'mkg-llm-data-select'
 */
@Component({
  selector: 'mkg-llm-rag_search_web',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatListModule, MatIconModule, NgFor, NgIf, MarkdownModule ],
  templateUrl: './rag_search_web.html',
  styleUrl: './rag_search_web.scss',
    providers:[
        { provide: ErrorHandler, useClass: CustomErrorHandler }
    ]
})
export class Rag_search_web implements OnInit, OnDestroy {
  private readonly CONSUMER_ID: UtilityMediaAccess.MicrophoneConsumer = 'RAG_SEARCH_WEB';

  /**
   *Injeccion de servicios necesarios para el funcionamineto del dialogComponent
   */
  store = inject(llmStoreService)
  private _accessMicSvc = inject(MicrophoneService);

  /**
   * Referencia al diálogo para controlar su cierre
   * @returns {string | undefined} ID del cliente seleccionado al cerrar
   */
  readonly dialogRef = inject(MatDialogRef<Rag_search_web, string | undefined>);

  /**
   * Datos inyectados en el diálogo con la lista de elementos<datos>
   */
  ObjData: any = inject(MAT_DIALOG_DATA);




  /**
   * Inicializa el componente.
   * Inicia la escucha de voz a través del servicio y se suscribe a sus resultados.
   */
  ngOnInit() {
    this._accessMicSvc.requestLock(this.CONSUMER_ID);
  }

  /**
   * Limpia recursos al destruir el componente.
   * Limpia el signal de `transcriptionSession` del servicio `commandSpeechService`
   */
  ngOnDestroy() {
    this._accessMicSvc.releaseLock(this.CONSUMER_ID);
  }

}
